import styled from "styled-components";

export const ProfitMarginContainer = styled.section`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 1px 1px 1px 1px rgba(178, 177, 177, 0.12);
`;

export const ProfitMarginHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
`;

export const ProfitMarginTitle = styled.h3`
  font-size: 1.1em;
  font-weight: 700;
  color: #222;
  margin: 0;
  padding: 0;
`;

export const MonthSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  font-size: 0.9em;
  font-family: 'Roboto', sans-serif;
  color: #222;
  background-color: #fff;
  cursor: pointer;
  outline: none;
  &:focus {
    border-color: #5E94F8;
  }
`;

export const MetricsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;

export const MetricCard = styled.div`
  flex: 1;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  padding: 15px;
  background-color: ${(props) => props.bgColor || "#f9f9f9"};
  border-radius: 8px;
`;

export const MetricLabel = styled.span`
  color: #aeaeae;
  font-size: 0.8em;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const MetricValue = styled.span`
  color: ${(props) => props.color || "#222"};
  font-size: 1.4em;
  font-weight: 700;
`;

export const MarginPercentage = styled.span`
  color: ${(props) => (props.value >= 0 ? "#0ACD81" : "#e74c3c")};
  font-size: 1.4em;
  font-weight: 700;
`;
